import { render, staticRenderFns } from "./OnboardStepItem.vue?vue&type=template&id=45874c40&scoped=true&"
import script from "./OnboardStepItem.vue?vue&type=script&lang=ts&"
export * from "./OnboardStepItem.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardStepItem.vue?vue&type=style&index=0&id=45874c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45874c40",
  null
  
)

export default component.exports